import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { setupSentry } from './helper/sentry';
import { setupAnalytics } from './helper/analytics';
import { ResetConfirmationModalProvider } from './contexts/ResetConfirmationModalContext';

setupSentry();

setupAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ResetConfirmationModalProvider>
      <App />
    </ResetConfirmationModalProvider>
  </React.StrictMode>,
);
